import GenerateFromMulesoft from "./Generate";
import MulesoftEndpoints from "./Endpoints";
import MulesoftServices from "./Services";
import MulesoftApiDocs from "./ApiDocs";
import MuleIntegrations from "./MuleIntegrations";
import * as slice from "./mulesoft.reducers";
import * as selectors from "./mulesoft.selectors";
import * as useQueryActions from "./mulesoft.actions";

export const {
  name,
  reducer,
  actions: {
    setSelectedMulesoftEndpoint,
    setMulesoftDeployStatus,
    setSelectedIntegration,
    setSelectedIntegrationId,
    setMulesoftSwaggerData,
    setMuleIntegrationsFilters,
  },
} = slice;

export const {
  fetchMulesoftEndpoints,
  createMulesoftEndpoint,
  deleteMulesoftEndpoint,
  fetchMulesoftSwaggerData,
  fetchMuleIntegrations,
  fetchIntegration,
  createIntegration,
  deleteMuleIntegration,
  updateIntegrationDetails,
} = useQueryActions;

export const {
  selectMulesoftEndpoints,
  selectMulesoftServices,
  selectMulesoftSwaggerData,
  selectSelectedMulesoftEndpoint,
  selectMulesoftDeployStatus,
  selectMuleIntegrations,
  selectSelectedIntegration,
  selectSelectedIntegrationId,
  selectMuleIntegrationsFilters,
} = selectors;

export {
  GenerateFromMulesoft,
  MulesoftEndpoints,
  MulesoftServices,
  MulesoftApiDocs,
  MuleIntegrations,
};
